import React, { useState, useEffect, useContext } from "react";
import { useManualQuery, useMutation, ClientContext } from "graphql-hooks";
import { Link, useNavigate } from "react-router-dom";
import PersistentDataGrid from "../../components/PersistentDataGrid";
import { useLocation } from "react-router-dom";
import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  Tooltip,
  Button,
  makeStyles,
  IconButton,
  TextField,
  MenuItem,
} from "@material-ui/core";
import styled from "styled-components";
import Box from "@mui/material/Box";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import TermsIcon from "@mui/icons-material/School";

import {
  REFRESH_TOKEN_MUTATION,
  UPDATE_USER_ISACTIVE,
  STAFF_MODULE_ACCESS_QUERY,
} from "../../graphQL/user_qry";
import { CLIENT_MEMBER_LIST } from "../../graphQL/clientMember";

import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";

import { project_url } from "../../constants/Data";

const StyledDateTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -45px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const StyledTooltipTerms = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "80px, -20px, 20px, -25px", //-75px, -40px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    background: #e2f2ff;
    color: #000;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.4px;
    display: inline-flex;
    padding: 8px 20px 15px 20px;
    flex-direction: column;
    align-items: center;
  }
`;
const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
  },
  ComponentDragBox: {
    float: "left",
  },
  FormDropBox: {
    float: "left",
    marginLeft: "5rem",
    marginTop: ".5rem",
  },
  onboardButtonStyle: {
    borderRadius: 4,
    width: "140px",
    padding: 0,
    color: "#fff",
    height: "48px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "120px",
    padding: 0,
    color: "#fff",
    height: "48px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
    "&:disabled": {
      backgroundColor: "#cccccc",
      color: "#666666",
    },
  },
  dataGridStyle: {
    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 12,
    },
  },
  tooltipStyle: {
    // paddingRight: 15,
    // cursor: "pointer",
    height: 24,
    weight: 24,
    paddingTop: 15,
  },
  textFieldStyle: {
    // marginBottom: 5,
    width: "180px",
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  selectStyle: {
    minWidth: 130,
    height: 45,
    // paddingRight: 16,
    "& .MuiOutlinedInput-input": {
      textAlign: "left",
    },
  },
}));

function ClientMembersList() {
  const navigate = useNavigate();
  const classes = useStyles();
  const client = useContext(ClientContext);
  const [pathname] = useState(window.location.pathname);
  const [reload, setReload] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [loadContent, setLoadContent] = useState(false);
  const [alertChgUserIsActiveDlg, setAlertChgUserIsActiveDlg] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const [searchedMemberList, setSearchedMemberList] = useState([]);
  const [firstNameSrch, setFirstNameSrch] = useState("");
  const [lastNameSrch, setLastNameSrch] = useState("");
  const [memberType, setMemberType] = useState(
    localStorage.getItem("memberType")
      ? localStorage.getItem("memberType")
      : "All",
  );
  // const [pageTitle, setPageTitle] = useState("Members List");
  // const [addButtonDisabled, setAddButtonDisabled] = useState(true);

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  let tenantUserId = 0;
  if (localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;
  if (localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  let loadData = true;
  if (localStorage.getItem("clientId")) clientId = localStorage.getItem("clientId");
  if (clientId == 0) loadData = false;

  let clientName = "";
  if (localStorage.getItem("clientName")) clientName = localStorage.getItem("clientName");

  const [access, setAccess] = useState(true);
  const [viewAccess, setViewAccess] = useState(false);
  const [editAccess, setEditAccess] = useState(false);
  const [termsAccess, setTermsAccess] = useState(false);
  const [lockAccess, setLockAccess] = useState(false);

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const [getClientMembersListQuery] = useManualQuery(CLIENT_MEMBER_LIST);
  const [updateUserIsActive] = useMutation(UPDATE_USER_ISACTIVE);

  const checkAccess = async () => {
    //check if staff has access to module

    const {
      loading: accessDataLoading,
      error: accessDataError,
      data: accessData,
    } = await checkStaffModuleAccess({
      variables: {
        tenantUserId: parseInt(tenantUserId),
        clientId: parseInt(clientId),
        moduleName: "Members",
        modulepageName: "List",
      },
    });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {
      setAccess(accessData.staffModuleAccess.access);
      let commonActions = accessData.staffModuleAccess.commonActions.split("|");
      if (commonActions.find(a => a == "View")) setViewAccess(true);

      if (commonActions.find(a => a == "Edit")) setEditAccess(true);

      let additionalActions = accessData.staffModuleAccess.additionalActions.split("|");

      if (additionalActions.find(a => a == "Terms")) setTermsAccess(true);
      if (additionalActions.find(a => a == "Activate/Deactivate")) setLockAccess(true);
    }

    if (
      accessDataError &&
      accessDataError.graphQLErrors &&
      accessDataError.graphQLErrors[0].message === "Signature has expired"
    ) {
      navigate(`${project_url}/signin`);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);

  const getMembersList = async () => {
    
    const {
      loading: loadingMembersList,
      error: errorMembersList,
      data: dataMembersList,
    } = await getClientMembersListQuery({
      variables: {
        clientId: parseInt(clientId),
      },
    });
    if (!loadingMembersList && dataMembersList && dataMembersList.getClientMember) {
      setMemberList(dataMembersList.getClientMember);
      let applicationMembers = dataMembersList.getClientMember;
      if (memberType === "Application") {
        applicationMembers = dataMembersList.getClientMember.filter(
          member => member.applicantId.viaForm === true,
        );
      };

      if (memberType === "Onboarded") {
        applicationMembers = dataMembersList.getClientMember.filter(
          member => member.applicantId.viaForm === false,
        );
      };

      setSearchedMemberList(applicationMembers);

      loadData = true;
    } else loadData = false;

    if (errorMembersList) {
      if (errorMembersList.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin`);
    }
  };

  const filterMembersByType = type => {
    let filteredMembers = [];
    if (type === "Application") {
      filteredMembers = memberList.filter(member => member.applicantId.viaForm === true);

      // setPageTitle("Members List");
      // setAddButtonDisabled(true);
    }

    if (type === "Onboarded") {
      filteredMembers = memberList.filter(member => member.applicantId.viaForm === false);

      // setPageTitle("Onboarded Members List");
      // setAddButtonDisabled(false);
    }

    if (type === "All") {
      filteredMembers = memberList;

      // setPageTitle("All Members List");
      // setAddButtonDisabled(false);
    }

    setSearchedMemberList(filteredMembers);
  };

  useEffect(() => {
    if (firstLoad) {
      window.scrollTo(0, 0);
      setFirstLoad(false);
    }
    (async () => getMembersList())();
  }, [reload]);

  const location = useLocation();

  useEffect(() => {    
  if (location.state?.refresh) {
    setFirstNameSrch("");
    setLastNameSrch("");
    localStorage.setItem("memberType","All");
    setMemberType("All");
    filterMembersByType("All")
    
  }
}, [location.state?.refresh]);

  const confirmChgUserIsActiveVal = (row, newVal) => {
    if (newVal) {
      setAlertChgUserIsActiveDlg({
        title: "Activate Member",
        type: "activeDeactiveUser",
        msg: 'Are you sure you want to activate member "' + row.name + '"?',
        butnVal: "Activate",
        userId: row.userId,
        status: newVal,
      });
    } else {
      setAlertChgUserIsActiveDlg({
        title: "Deactivate Member",
        type: "activeDeactiveUser",
        msg: 'Are you sure you want to deactivate member "' + row.name + '"?',
        butnVal: "Deactivate",
        userId: row.userId,
        status: newVal,
      });
    }
  };

  const updateUserActive = async (userId, status) => {
    let {
      loading: loadMutation,
      error: errorMutation,
      data: dataMutation,
    } = await updateUserIsActive({
      variables: {
        userId: parseInt(userId),
        isActive: status,
      },
    });

    if (!loadMutation && dataMutation.updateUserIsactive.response) {
      setReload(!reload);
    } else {
      console.log(errorMutation);
      // alert(errorMutation);
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Name",
      minWidth: 170,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 200,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "linkedinUrl",
      headerName: "LinkedIn URL",
      minWidth: 200,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "city",
      headerName: "City",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "country",
      headerName: "Country",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "action",
      headerName: "Action",
      minWidth: 240,
      flex: 2,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        var editCursor = rows.row.editAccess ? "pointer" : "auto";

        var termsCursor = rows.row.termsAccess ? "pointer" : "auto";

        var lockCursor = rows.row.lockAccess ? "pointer" : "auto";

        return (
          <Box
            pt={1}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            {rows.row.isActive ? (
              <StyledTooltip title="Deactivate member">
                <IconButton
                  className={classes.tooltipStyle}
                  style={{ cursor: lockCursor }}
                >
                  <LockOutlinedIcon
                    color={rows.row.lockAccess ? "action" : "disabled"}
                    onClick={() =>
                      rows.row.lockAccess
                        ? confirmChgUserIsActiveVal(rows.row, false)
                        : ""
                    }
                  />
                </IconButton>
              </StyledTooltip>
            ) : (
              <StyledTooltip title="Activate member">
                <IconButton
                  className={classes.tooltipStyle}
                  style={{ cursor: lockCursor }}
                >
                  <LockOpenOutlinedIcon
                    color={rows.row.lockAccess ? "action" : "disabled"}
                    onClick={() =>
                      rows.row.lockAccess ? confirmChgUserIsActiveVal(rows.row, true) : ""
                    }
                  />
                </IconButton>
              </StyledTooltip>
            )}
            <StyledTooltip title="Edit member">
              <IconButton className={classes.tooltipStyle} style={{ cursor: editCursor }}>
                <EditOutlinedIcon
                  color={rows.row.editAccess ? "action" : "disabled"}
                  onClick={() =>
                    rows.row.editAccess
                      ? navigate(`${project_url}/members/` + rows.row.id)
                      : ""
                  }
                />
              </IconButton>
            </StyledTooltip>
            <StyledTooltip title="Member Terms">
              <TermsIcon
                color={rows.row.termsAccess ? "action" : "disabled"}
                style={{
                  paddingRight: 15,
                  paddingTop: 6,
                  cursor: termsCursor,
                  fontSize: 24,
                }}
                onClick={() =>
                  rows.row.termsAccess
                    ? navigate(`${project_url}/members/` + rows.row.username + "/terms")
                    : ""
                }
              />
            </StyledTooltip>
          </Box>
        );
      },
    },
  ];

  var rows = searchedMemberList.map(member => ({
    id: member.clientMemberId,
    userId: member.applicantId.userId.id,
    username: member.applicantId.userId.username,
    name: member.applicantId.userId.firstName + " " + member.applicantId.userId.lastName,
    email: member.applicantId.userId.email,
    linkedinUrl: member.applicantId.userId.linkedinUrl,
    city: member.applicantId.userId.city,
    country: member.applicantId.userId.country,
    isActive: member.applicantId.userId.isActive,
    status: member.applicantId.userId.isActive ? "Active" : "Inactive",
    editAccess: editAccess,
    termsAccess: termsAccess,
    lockAccess: lockAccess,
  }));

  const applySearch = e => {
    e.preventDefault();

    const result = memberList.filter(member => {
      const firstNameMatch =
        firstNameSrch === "" ||
        member.applicantId.userId.firstName
          .toLowerCase()
          .includes(firstNameSrch.toLowerCase());

      const lastNameMatch =
        lastNameSrch === "" ||
        member.applicantId.userId.lastName
          .toLowerCase()
          .includes(lastNameSrch.toLowerCase());

      return firstNameMatch && lastNameMatch;
    });

    setSearchedMemberList(result);
  };

  const onKeyPress = e => {
    if (e.key === "Enter") applySearch(e);
  };

  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          xs={12}
          style={{
            paddingTop: 15, //5,
            paddingBottom: 15, //6,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={10} style={{ textAlign: "center" }}>
            <Typography variant="h1" style={{ fontSize: 20 }}>
              Members List
            </Typography>
          </Grid>
          {/* <Grid
            item
            xs={2}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: 10,
            }}
          >
            <Button
              variant="contained"
              size="small"
              className={classes.buttonStyle}
              onClick={() => navigate(`${project_url}/users/add`)}
            >
              Add
            </Button>
          </Grid> */}
        </Grid>
        <Divider />
      </>
    );
  }
  if (loadContent)
    if (loadData)
      if (access)
        return (
          <div className={classes.root}>
            <Header />
            <div className={classes.container}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <FormControl>
                  <InputLabel>
                    Member Type
                  </InputLabel>
                  <Select
                    label="Member Type"
                    className={classes.selectStyle}
                    margin="normal"
                    value={memberType}
                    onChange={e => {
                      localStorage.setItem("memberType", e.target.value);
                      setMemberType(e.target.value);
                      filterMembersByType(e.target.value);
                    }}
                  >
                    <MenuItem value="All">All</MenuItem>
                    <MenuItem value="Application">Application</MenuItem>
                    <MenuItem value="Onboarded">Onboarded</MenuItem>
                  </Select>
                </FormControl>
                <Button
                  variant="contained"
                  className={classes.onboardButtonStyle}
                  // disabled={addButtonDisabled}
                  onClick={() => navigate(`${project_url}/members/add`)}
                >
                  Add Onboarded
                </Button>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  mb: 2,
                }}
              >
                <TextField
                  className={classes.textFieldStyle}
                  label="First Name"
                  // margin="normal"
                  type="text"
                  variant="outlined"
                  value={firstNameSrch}
                  onChange={e => {
                    setFirstNameSrch(e.target.value);
                  }}
                  onKeyPress={onKeyPress}
                />

                <TextField
                  className={classes.textFieldStyle}
                  label="Last Name"
                  // margin="normal"
                  type="text"
                  variant="outlined"
                  value={lastNameSrch}
                  onChange={e => {
                    setLastNameSrch(e.target.value);
                  }}
                  onKeyPress={onKeyPress}
                />

                <Button
                  variant="contained"
                  color="primary"
                  className={classes.buttonStyle}
                  onClick={applySearch}
                >
                  Search
                </Button>
              </Box>
              <PersistentDataGrid
                persistenceKey="members-list"
                className={classes.dataGridStyle}
                columns={columns}
                rows={rows}
                showCellRightBorder={true}
                slots={{
                  toolbar: DataGridTitle,
                }}
                getRowId={row => row.id}
                autoHeight={true}
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 10,
                    },
                  },
                }}
                pageSizeOptions={[10, 25, 50]}
              />
              {alertChgUserIsActiveDlg.msg && (
                <AlertDialog
                  title={alertChgUserIsActiveDlg.title}
                  type={alertChgUserIsActiveDlg.type}
                  contentMsg={alertChgUserIsActiveDlg.msg}
                  closeDialog={() => setAlertChgUserIsActiveDlg([])}
                  activeDeactiveUserFunc={() => {
                    setAlertChgUserIsActiveDlg([]);
                    updateUserActive(
                      alertChgUserIsActiveDlg.userId,
                      alertChgUserIsActiveDlg.status,
                    );
                  }}
                  activeDeactiveUserButn={alertChgUserIsActiveDlg.butnVal}
                />
              )}
            </div>
          </div>
        );
      else
        return (
          <div className={classes.root}>
            <div className={classes.container}>
              <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.'
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            </div>
          </div>
        );
    else
      return (
        <div className={classes.root}>
          <div className={classes.container}>
            <AlertDialog
              title="No Client"
              contentMsg="There is no client in this Tenant. Please create a client."
              closeDialog={() => {
                navigate(`${project_url}/tenant/dashboard`);
              }}
            />
          </div>
        </div>
      );
  else return;
}

export default ClientMembersList;
